(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-paiement', {
            parent: 'entity',
            url: '/reporting-paiement',
            data: {
                authorities: ['ROLE_READ_ONLY','ROLE_DATA_OPERATOR'],
                pageTitle: 'wamasysApp.reportingPaiement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-paiement/reporting-paiement.html',
                    controller: 'ReportingPaiementController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('contrat');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
